<template>
  <el-col class="chart-module" :lg="12" v-loading="loading">
    <div class="sub-view">
      <el-row class="no-search">
        <span style="font-weight: bold">{{ displayTitle }}</span>
        <i
          class="el-icon-close"
          v-if="$root.editMode"
          @click="$root.onClose(title)"
        ></i>
        <i class="el-icon-zoom-in" v-else @click="showPopUp()"></i>
      </el-row>
      <hr />
      <el-row>
        <echarts
          :autoresize="true"
          class="chart-view"
          :option="option"
          @click="onClick"
          @timelinechanged="timelinechanged"
        />
      </el-row>
      <el-dialog
        :visible.sync="popUpDisplay"
        :append-to-body="true"
        class="historyDailog"
      >
        <template slot="title">
          <el-row>
            <span style="font-weight: bold">{{ displayTitle }}</span>
          </el-row>
        </template>
        <hr />
        <echarts
          :autoresize="true"
          :option="option"
          style="height: 75vh"
          @click="onClick"
          @timelinechanged="timelinechanged"
        />
      </el-dialog>
    </div>
  </el-col>
</template>

<script>
import api from "@/api";
var moment = require("moment-timezone");

export default {
  name: "ChatbotProcessCountChart",
  props: ["title", "displayTitle"],
  data() {
    return {
      endDate: this.$root.endDate,
      option: this.option,
      loading: this.loading,
      popUpDisplay: this.popUpDisplay,
      paramTitle: "全体",
    };
  },
  mounted() {
    this.$bus.$on("changeEndMonth", (startDate, endDate) => {
      this.endDate = endDate;
      this.bashMonthChange();
    });
  },
  created() {
    let self = this;
    self.loading = true;

    api.getChatbotTicketCountByMonth(this.endDate,self.$root.facetForEchart,self.$root.ageForEchart,self.$root.sexForEchart).then(
      (res) => {
        let data = res.data;
        let year_list = data.year_list;
        let data_list = [];
        let time_line = data.facets;
        for (let i in data.output_list) {
          let obj = {
            title: {
              text: data.facets[i],
            },
            xAxis: [
              {
                data: data.month_list,
              },
            ],
            series: data.output_list[i],
          };
          data_list.push(obj);
        }
        self.option = {
          baseOption: {
            title: {
              right: "10%",
            },
            legend: {
              top: 20,
              data: year_list,
            },
            timeline: {
              axisType: "category",
              autoPlay: false,
              playInterval: 1000,
              data: time_line,
              label: {
                show: false,
                interval: 0,
                formatter: function (s) {
                  return s;
                },
              },
              padding: [10, -100],
            },
            tooltip: {
              trigger: "axis",
            },
            calculable: true,
            grid: {
              top: 80,
              bottom: 80,
              tooltip: {
                trigger: "axis",
                axisPointer: {
                  type: "shadow",
                  label: {
                    show: true,
                    formatter: function (params) {
                      return params.value.replace("\n", "");
                    },
                  },
                },
              },
            },
            xAxis: [
              {
                type: "category",
                axisLabel: {
                  interval: 0,
                },
                data: data.month_list,
                splitLine: {
                  show: false,
                },
              },
            ],
            yAxis: [
              {
                type: "value",
                name: "件数",
                minInterval: 1,
              },
            ],
            series: [
              {
                name: "件数",
                type: "line",
              },
            ],
          },
          options: data_list,
        };
        self.loading = false;
      },
      (err) => {
        console.log(err);
      }
    );
  },
  methods: {
    timelinechanged(params) {
      this.paramTitle = this.option.options[params.currentIndex].title.text;
    },
    onClick(params) {
      if (params.componentType == "series") {
        let startDate = "";
        let endDate = "";
        let baseEndDate = this.endDate.substring(5, 7);
        let baseYear = params.seriesName.substring(1, 5);
        if (Number(params.name.replace("月", "")) <= Number(baseEndDate)) {
          startDate = moment(baseYear + "-" + params.name.replace("月", ""))
            .startOf("month")
            .format("YYYY-MM-DD");
          endDate = moment(baseYear + "-" + params.name.replace("月", ""))
            .endOf("month")
            .format("YYYY-MM-DD");
        } else {
          baseYear = Number(baseYear) - 1;
          startDate = moment(baseYear + "-" + params.name.replace("月", ""))
            .startOf("month")
            .format("YYYY-MM-DD");
          endDate = moment(baseYear + "-" + params.name.replace("月", ""))
            .endOf("month")
            .format("YYYY-MM-DD");
        }

        let ageAndSexStr = '';
        if (this.$root.ageForEchart != '') {
          ageAndSexStr += "&f%5B%5D=cf_89&op%5Bcf_89%5D=~&v%5Bcf_89%5D%5B%5D=" + this.$root.ageForEchart[0];
        }
        if (this.$root.sexForEchart != '') {
          ageAndSexStr += "&f%5B%5D=cf_90&op%5Bcf_90%5D=~&v%5Bcf_90%5D%5B%5D=" + this.$root.sexForEchart[0];
        }
        if (this.paramTitle == "全体") {
          window.open(
            this.$root.redmineUrl +
              "/projects/aicc-redmine/issues?utf8=%E2%9C%93&set_filter=1&sort=id%3Adesc&f%5B%5D=status_id&op%5Bstatus_id%5D=c&f%5B%5D=created_on&op%5Bcreated_on%5D=%3E%3C&v%5Bcreated_on%5D%5B%5D=" +
              startDate +
              "&v%5Bcreated_on%5D%5B%5D=" +
              endDate +
              "&f%5B%5D=tracker_id&op%5Btracker_id%5D=%3D&v%5Btracker_id%5D%5B%5D=2&f%5B%5D=&c%5B%5D=tracker&c%5B%5D=cf_45&c%5B%5D=cf_3&c%5B%5D=category&c%5B%5D=cf_22&c%5B%5D=subject&c%5B%5D=cf_37&c%5B%5D=cf_80&c%5B%5D=assigned_to&c%5B%5D=created_on&c%5B%5D=status&c%5B%5D=cf_43&group_by=&t%5B%5D="
              + ageAndSexStr
          );
        } else {
          window.open(
            this.$root.redmineUrl +
              "/projects/aicc-redmine/issues?utf8=%E2%9C%93&set_filter=1&sort=id%3Adesc&f%5B%5D=status_id&op%5Bstatus_id%5D=c&f%5B%5D=created_on&op%5Bcreated_on%5D=%3E%3C&v%5Bcreated_on%5D%5B%5D=" +
              startDate +
              "&v%5Bcreated_on%5D%5B%5D=" +
              endDate +
              "&f%5B%5D=tracker_id&op%5Btracker_id%5D=%3D&v%5Btracker_id%5D%5B%5D=2&f%5B%5D=cf_22&op%5Bcf_22%5D=%7E&v%5Bcf_22%5D%5B%5D=" +
              this.paramTitle +
              "&f%5B%5D=&c%5B%5D=tracker&c%5B%5D=cf_45&c%5B%5D=cf_3&c%5B%5D=category&c%5B%5D=cf_22&c%5B%5D=subject&c%5B%5D=cf_37&c%5B%5D=cf_80&c%5B%5D=assigned_to&c%5B%5D=created_on&c%5B%5D=status&c%5B%5D=cf_43&group_by=&t%5B%5D="
              + ageAndSexStr
          );
        }
      }
    },
    showPopUp() {
      this.popUpDisplay = true;
    },
    bashMonthChange() {
      let self = this;
      self.loading = true;

      api.getChatbotTicketCountByMonth(this.endDate,self.$root.facetForEchart,self.$root.ageForEchart,self.$root.sexForEchart).then(
        (res) => {
          let data = res.data;
          let year_list = data.year_list;
          let data_list = [];
          let time_line = data.facets;
          for (let i in data.output_list) {
            let obj = {
              title: {
                text: data.facets[i],
              },
              xAxis: [
                {
                  data: data.month_list,
                },
              ],
              series: data.output_list[i],
            };
            data_list.push(obj);
          }
          self.option = {
            baseOption: {
              title: {
                right: "10%",
              },
              legend: {
                top: 20,
                data: year_list,
              },
              timeline: {
                axisType: "category",
                autoPlay: false,
                playInterval: 1000,
                data: time_line,
                label: {
                  show: false,
                  interval: 0,
                  formatter: function (s) {
                    return s;
                  },
                },
                padding: [10, -100],
              },
              tooltip: {
                trigger: "axis",
              },
              calculable: true,
              grid: {
                top: 80,
                bottom: 80,
                tooltip: {
                  trigger: "axis",
                  axisPointer: {
                    type: "shadow",
                    label: {
                      show: true,
                      formatter: function (params) {
                        return params.value.replace("\n", "");
                      },
                    },
                  },
                },
              },
              xAxis: [
                {
                  type: "category",
                  axisLabel: {
                    interval: 0,
                  },
                  data: data.month_list,
                  splitLine: {
                    show: false,
                  },
                },
              ],
              yAxis: [
                {
                  type: "value",
                  name: "件数",
                  minInterval: 1,
                },
              ],
              series: [
                {
                  name: "件数",
                  type: "line",
                },
              ],
            },
            options: data_list,
          };
          self.loading = false;
        },
        (err) => {
          console.log(err);
        }
      );
    },
  },
};
</script>
<style>
</style>
